<template>
	<div class="c-script-brief">
		<h3>Select brief</h3>
		<article class="article-text-sm">
			<p>Brief helps give relevant context to the script writer.</p>
		</article>
		<div class="c-script-brief__switcher" v-if="!createBrief">
			<article>
				<strong> Select an existing brief </strong>
				<InputBrief @input="onBriefSelect"></InputBrief>
				<button
					type="button"
					:class="['btn btn-box', { 'btn-primary': !!briefId }]"
					@click="next"
				>
					<span> Next </span>
				</button>
			</article>
			<hr />
			<article>
				<strong> Create a brief </strong>
				<button type="button" class="btn btn-box" @click="createBrief = true">
					Create
				</button>
			</article>
		</div>
		<template v-if="createBrief">
			<ul>
				<li :class="[{ active: step === 'scan' }]">
					<span> 1 </span>
					<section>
						<strong> Scan your landing page </strong>
						<p>
							We’ll scan your landing page and prefill key details for your
							brief.
						</p>
						<FormBriefCreateUrl
							@onSkip="onSkip"
							@onSubmit="onPageAnalyzed"
						></FormBriefCreateUrl>
					</section>
				</li>
				<li :class="[{ active: step === 'create' }]">
					<span> 2 </span>
					<section>
						<strong> Complete your brief </strong>
						<p>
							Review and fill in any missing info. Your brief will be saved for
							future use.
						</p>
						<FormBrief
							v-if="tempBriefData || step === 'create'"
							:brief="tempBriefData"
							@onSubmit="onSubmit"
						></FormBrief>
					</section>
				</li>
			</ul>
		</template>

		<!-- <article class="article-text-sm">
			<div class="text-center">
				<button type="button" class="btn btn-primary btn-icon" @click="next">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M10 16L13.4697 12.5303C13.7626 12.2374 13.7626 11.7626 13.4697 11.4697L10 8"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<span> Save </span>
				</button>
				<br />
				<small> Once saved, this brief will be available in the future. </small>
			</div>
		</article> -->
	</div>
</template>

<script>
import InputBrief from '@swipekit/components/form/input-brief.vue';
import FormBriefCreateUrl from '@swipekit/components/form/form-brief-create-url.vue';
import FormBrief from '@swipekit/components/form/form-brief.vue';

export default {
	components: {
		InputBrief,
		FormBriefCreateUrl,
		FormBrief,
	},

	data: function () {
		return {
			createBrief: false,
			briefId: false,
			tempBriefData: null,

			step: 'scan',
		};
	},

	computed: {
		briefs: function () {
			return this.$store.getters['briefs/filtered'];
		},
	},

	methods: {
		next: function () {
			this.$emit('next', {
				briefId: this.briefId,
			});
		},
		onBriefSelect: function (briefId) {
			this.briefId = briefId;
		},
		onSkip: function () {
			this.step = 'create';
		},
		onPageAnalyzed: function (data) {
			console.log(data);
			this.tempBriefData = data;
			this.step = 'create';
		},
		onSubmit: function (brief) {
			this.briefId = brief.id;

			this.$emit('next', {
				briefId: this.briefId,
			});
		},
	},

	created: function () {
		if (this.briefs && this.briefs.length > 0) {
		} else {
			this.createBrief = true;
		}
	},
};
</script>

<style lang="scss">
.c-script-brief {
	margin: 0 auto;
	width: var(--page-width);
	background-color: var(--color-bg-1);
	padding: 1rem;
	border-radius: 0.5rem;
	border: var(--color-bg-3) solid 1px;

	h3 {
		text-align: center;
		margin-bottom: 1rem;
	}

	&__switcher {
		strong {
			display: block;
			margin-bottom: 0.5rem;
			font-weight: 500;
		}

		.btn {
			width: 100%;
		}

		article {
			text-align: center;
		}

		hr {
			position: relative;

			&:before {
				display: block;
				padding: 0.25rem;
				content: 'OR';
				position: absolute;
				z-index: 1;
				top: 4px;
				left: calc(50% - 15px);
				background-color: var(--color-bg-1);
			}
		}
	}

	ul {
		list-style: none;
		margin: 0;
		padding: 0;

		li {
			display: grid;
			grid-template-columns: 20px 1fr;
			grid-column-gap: var(--margin);

			opacity: 0.6;
			pointer-events: none;
			padding-left: 0;

			&:before {
				content: none;
			}

			&.active {
				opacity: 1;
				pointer-events: initial;
			}

			> span {
				display: inline-flex;
				margin-top: var(--margin-sm);
				justify-content: center;
				align-items: center;
				width: 20px;
				height: 20px;
				background-color: var(--color-bg-99);
				border-radius: 99px;
				color: var(--color-bg-1);
				font-size: var(--font-size-xs);
				font-weight: 500;
				font-feature-settings: 'case' 0, 'dlig' 0, 'frac' 0, 'dnom' 0, 'numr' 0,
					'subs' 0, 'sups' 0, 'tnum', 'zero' 0, 'ss01', 'ss02' 0, 'ss03' 0,
					'ss04', 'ss05' 0, 'ss06' 0, 'ss07' 0, 'ss08' 0, 'cv01' 0, 'cv02' 0,
					'cv03' 0, 'cv04' 0, 'cv05' 0, 'cv06' 0, 'cv07' 0, 'cv08' 0, 'cv09' 0,
					'cv10' 0, 'cv11' 0, 'cv12' 0, 'cv13' 0, 'cpsp' 0, 'c2sc' 0, 'salt' 0,
					'aalt' 0, 'calt', 'ccmp', 'locl', 'kern';
			}

			section {
				> p {
					font-size: var(--font-size-xs);
				}
			}
		}
	}
}
</style>
